import Image from 'next/image';
import {
  MouseParallaxContainer,
  MouseParallaxChild,
} from 'react-parallax-mouse';
import { useMediaQuery } from 'react-responsive';
import { Button, Htag, HtagAlign, HtagVariant } from '../../components';
import styles from './logistic-intro.module.css';
import plane from '../../public/logistic/plane-min.png';
import track from '../../public/logistic/track-min.png';
import gifts from '../../public/logistic/gifts-min.png';
import ship from '../../public/logistic/ship-min.png';
import cloud from '../../public/logistic/cloud.png';
import Check from '../../public/logistic/check.svg';

export default function LogisticIntro() {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  return (
    <div className={styles.root}>
      <MouseParallaxContainer
        className={styles.container}
        globalFactorX={0.1}
        globalFactorY={0.1}
        enabled={!isMobile}
      >
        <div className={styles.wrapper}>
          <Htag
            variant={HtagVariant.h2}
            align={HtagAlign.center}
            className={styles.title}
          >
            transportation and Logistics Software Development
          </Htag>
          <ul className={styles.list}>
            <li className={styles.item}>
              <div className={styles.card}>
                <Check className={styles.icon} />
                Optimizing supply chains to minimize costs
              </div>
            </li>
            <li className={styles.item}>
              <div className={styles.card}>
                <Check className={styles.icon} />
                Helping clients track their packages to increase customer
                satisfaction
              </div>
            </li>
            <li className={styles.item}>
              <div className={styles.card}>
                <Check className={styles.icon} />
                Automating warehouse processes to provide high accuracy
              </div>
            </li>
          </ul>
          <span className={styles.button}>
            <Button tag="a" appearance="primary" href="/contact">
              Start a project
            </Button>
          </span>
          <MouseParallaxChild
            className={styles.cloud}
            factorX={0.1}
            factorY={0.1}
          >
            <Image alt="Cloud picture" width={1118} height={340} src={cloud} />
          </MouseParallaxChild>
          <MouseParallaxChild
            className={styles.plane}
            factorX={0.1}
            factorY={0.1}
            inverted
          >
            <Image alt="Plane picture" width={442} height={246} src={plane} />
          </MouseParallaxChild>
          <MouseParallaxChild
            className={styles.ship}
            factorX={0.08}
            factorY={0.04}
            inverted
          >
            <Image alt="Ship picture" width={757} height={757} src={ship} />
          </MouseParallaxChild>
          <MouseParallaxChild
            className={styles.track}
            factorX={0.2}
            factorY={0.2}
          >
            <Image alt="Track picture" width={469} height={453} src={track} />
          </MouseParallaxChild>
          <MouseParallaxChild
            className={styles.gifts}
            factorX={0.04}
            factorY={0.08}
            inverted
          >
            <Image alt="Gifts picture" width={145} height={213} src={gifts} />
          </MouseParallaxChild>
        </div>
      </MouseParallaxContainer>
    </div>
  );
}
